import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';

import { IntelligenceSettingsHttpClient } from './intelligence-settings-http-client';
import { IntelligenceSettingsActions } from './intelligence-settings.store';

@Injectable({ providedIn: 'root' })
export class IntelligenceSettingsEffects {
  private readonly http = inject(IntelligenceSettingsHttpClient);
  private readonly actions = inject(Actions);

  private fetch$ = createEffect(() =>
    this.actions.pipe(
      ofType(IntelligenceSettingsActions.fetch),
      switchMap(() =>
        this.http.fetch().pipe(
          map(data => IntelligenceSettingsActions.fetchSuccess({ payload: data })),
          catchError(error => of(IntelligenceSettingsActions.fetchFailed({ payload: error }))),
        ),
      ),
    ),
  );

  private update$ = createEffect(() =>
    this.actions.pipe(
      ofType(IntelligenceSettingsActions.update),
      mergeMap(({ payload }) =>
        this.http.update(payload).pipe(
          map(data => IntelligenceSettingsActions.updateSuccess({ payload: data })),
          catchError(error => of(IntelligenceSettingsActions.updateFailed({ payload: error }))),
        ),
      ),
    ),
  );
}
